import { GetServerSideProps } from "next"
import React from "react"
import { Layout } from "src/features/subscriptionCentre"
import { Heading } from "@puregym/ui"
import {
  checkAuth,
  compose,
  getTranslations,
  getUserAgent,
} from "src/utilities/getServerSideProps"
import { useTranslation } from "src/i18next"
import { RenderHtml } from "src/components/renderHtml"
import { NextPageWithLayout } from "src/utilities/common"

export const Complete: NextPageWithLayout = () => {
  const { t } = useTranslation("marketingPreferences")
  return (
    <main id="main" data-testid="completed">
      <Heading as="h2">{t("completeTitle")}</Heading>
      <hr />
      <RenderHtml html={t("completeText")} />
    </main>
  )
}

Complete.getLayout = function CompleteLayout(page: React.ReactElement) {
  return <Layout>{page}</Layout>
}

Complete.fullWidth = false

export const getServerSideProps: GetServerSideProps = async context => {
  return compose(
    getUserAgent,
    checkAuth(false),
    getTranslations(["marketingPreferences"]),
  )(context)
}

export default Complete
